module.exports = __webpack_public_path__ + "img/globalnda-dark-yellow.be5c18dd.png";